import React, { useEffect, useState } from 'react'
import classNames from 'classnames'

import styles from './LegalDocsLoad.module.scss'
import { getLegalDocs } from '../../utils/legalAPIs'
import { useSpinnerContext } from '../../context/SpinnerContext'
import { toast } from 'react-toastify'

const LegalDocsLoad = ({ legalTypes, title }) => {
  const [data, setData] = useState([])
  const { isLoading, setIsLoading } = useSpinnerContext()

  useEffect(async () => {
    setIsLoading(true)
    const response = await getLegalDocs(legalTypes)
    if (response.data) {
      setData(response.data)
    } else {
      toast.error(`An unexpected error has occurred.`)
    }
    setIsLoading(false)
  }, [])

  if (isLoading) return null
  return (
    data &&
    data.map((agreement, index) => (
      <React.Fragment key={index}>
        <h1 className={classNames(styles.titleHeader, 'h3')}>{title || agreement.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: agreement.body }} />
      </React.Fragment>
    ))
  )
}

export default LegalDocsLoad
